Vendd.Scripts.load(function () {
    var $wrapper = $('.gallery-look-container');

    initCarousel();
    initFancybox();

    function initCarousel() {
        var $mainGallery = $($wrapper);

        if ($mainGallery.length < 1)
            return;

        var sliderMain = new Swiper($mainGallery, {
            threshold: 5,
            autoHeight: true,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        });
    };

    function initFancybox() {

        var $fancyLinks = $('.look-fancybox-gallery', $wrapper);


        if ($fancyLinks.length < 1)
            return;

        var fbOpts = {
            protect: true,
            infobar: true
        };

        $fancyLinks.fancybox(fbOpts);

        $('.fancy-btn', $wrapper).on('click', function (e) {
            var $slideWrapper = $('.gallery-look-container.swiper-initialized');
            if ($slideWrapper.length > 0) {
                $('.swiper-slide-active', $slideWrapper).find('.look-fancybox-gallery').trigger('click');
            }

        });
    };
});
